<div>
  <blockquote>

    @for (config of templateConfig; track config) {
      @if (promptProfile[config.key]) {
        <span>{{ config.before }} <strong>{{ promptProfile[config.key] }}</strong>{{ config.after }}</span>
      }
    }

  </blockquote>
  <div id="presend-options">
    <div>
      <label for="removeBias">Remove Bias</label>
      <mat-checkbox id="removeBias" [(ngModel)]="promptProfile['removeBias']"></mat-checkbox>
    </div>
    <div>
      <label for="removeBias">Anonymise</label>
      <mat-checkbox id="anonymize" [(ngModel)]="promptProfile['anonymise']"></mat-checkbox>
    </div>
  </div>

</div>
